var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "vs-tabs",
            { attrs: { color: _vm.colorx } },
            [
              _c(
                "vs-tab",
                { attrs: { label: _vm.$t("functionality.title") } },
                [
                  _c("div", { staticClass: "flex flex-col gap-4" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-2" },
                      [
                        _c("validation-observer", {
                          ref: "validator",
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var valid = ref.valid
                                return [
                                  _c(
                                    "b-form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return _vm.createOrUpdate.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        staticClass: "flex-grow",
                                        attrs: {
                                          name: _vm.$t("functionality.name"),
                                          rules: "required",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "input-group-1",
                                                        label:
                                                          _vm.$t(
                                                            "functionality.name"
                                                          ),
                                                        "label-for":
                                                          "functionality_name",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass: "required",
                                                        attrs: {
                                                          id: "functionality_name",
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                          name: "functionality_name",
                                                        },
                                                        model: {
                                                          value: _vm.model.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.name",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-1",
                                            label: _vm.$t(
                                              "functionality.description"
                                            ),
                                            "label-for":
                                              "functionality_description",
                                          },
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            attrs: {
                                              id: "functionality_description",
                                              rows: "4",
                                            },
                                            model: {
                                              value: _vm.model.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "model.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "w-full flex gap-2 justify-end" },
                      [
                        !_vm.isEdit()
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "functionalities.create",
                                    expression: "'functionalities.create'",
                                  },
                                ],
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm,
                                },
                                on: { click: _vm.createOrUpdate },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("action.save")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "functionalities.edit",
                                    expression: "'functionalities.edit'",
                                  },
                                ],
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm,
                                },
                                on: { click: _vm.createOrUpdate },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("action.save")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.goBack },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "CornerUpLeftIcon" },
                            }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(_vm._s(_vm.$t("back"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm.isEdit()
                ? _c(
                    "vs-tab",
                    { attrs: { label: _vm.$t("actions") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vx-row mb-6",
                          staticStyle: { "padding-top": "30px" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "vx-col w-full" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary", icon: "add" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showPopupPermission = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("adicionar")) + " "
                                  ),
                                ]
                              ),
                              _c("vs-divider"),
                              _c("Grid", {
                                key: _vm.gridKey,
                                ref: "grid-permission",
                                attrs: {
                                  service: _vm.service,
                                  route_name: "functionalities",
                                  order_column: "name",
                                  route_grid_path: _vm.permissionsFuncPath,
                                  route_delete_path: _vm.permissionsFuncPath,
                                  hide_edit: "true",
                                  delegate: {
                                    destroy: function () {
                                      return _vm.destroyPermissionFunctionality
                                    },
                                  },
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "w-full flex gap-2 justify-end",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right",
                                      attrs: { variant: "outline-secondary" },
                                      on: { click: _vm.goBack },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "CornerUpLeftIcon" },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "align-middle" },
                                        [_vm._v(_vm._s(_vm.$t("back")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("permission-popup", {
                        attrs: {
                          visible: _vm.showPopupPermission,
                          filters: _vm.filtersGridPermission,
                        },
                        on: {
                          selected: _vm.addPermissionsList,
                          close: _vm.closePopup,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }